import { render } from "./OtherContactList.vue?vue&type=template&id=13458716&scoped=true"
import script from "./OtherContactList.vue?vue&type=script&lang=js"
export * from "./OtherContactList.vue?vue&type=script&lang=js"

import "./OtherContactList.vue?vue&type=style&index=0&id=13458716&lang=scss&scoped=true"

import exportComponent from "/home/ubuntu/kokoroduke-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13458716"]])

export default __exports__